export class Dashboard {
    constructor() {
        console.info('It Works!');
    }
}
